import React from 'react';
import styled from 'styled-components';
import Label from '../label';
import Spinner from './spinner';
import { IntlMessages } from '../../../helper/langHelper';

const LoaderWrapper = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  margin: auto;
`;

export const Loader = (props) => {
  const {
    size = 'extraMedium',
    loadingText = <IntlMessages id="loading.text" defaultMessage="Loading..." />,
    isNotRequiredLoadingText = false,
  } = props;
  return (
    <LoaderWrapper>
      <Spinner size={size} />
      <Label
        style={{ color: '#717171' }}
        varient="italic"
        weight="italic"
        display={'block'}
        align="center"
        transform="initial"
      >
        {!isNotRequiredLoadingText && loadingText}
      </Label>
    </LoaderWrapper>
  );
};
